// @flow
import React from 'react'
import I18n from 'i18n-react'

// components
import QuoteHelpComponent from './QuoteHelpComponent'

// types
import type { ColumnTypeDefaultProps } from './ColumnTypeDefault'

const ColumnTypeHelp = (props: ColumnTypeDefaultProps) => {
  return (
    <div className='d-flex flex-row justify-content-end align-items-center'>
      {props.data.help && props.data.help.usp && Array.isArray(props.data.help.usp) &&
      <span className='d-lg-inline-block mr-2'>
        {props.data.help.usp.map((usp) => (
          <span className='d-lg-block' key={usp}>
            <span
              className='badge badge-active-object text-dark text-wrap ml-3 ml-lg-0 mr-1 my-1'
              key={`quote-insuranceCompany-liabilityInsurance-${props.quote.id}`}
            >
              {I18n.translate(`quoteHelp.${usp}`)}
            </span>
          </span>
        ))}
      </span>
      }
      {!!props.data.help &&
      <QuoteHelpComponent
        documents={props.documents}
        help={props.data.help}
        id={`ID${props.columnConfig.key}-quote-${props.quote.id}-help-mobile`}
        key={`quote-insuranceCompany-help-mobile-${props.quote.id}`}
        onClose={props.onCloseHelp}
        pushOpen={props.showHelp}
        target={`column-${props.quote.id}-name`}
        templateVariables={props.templateVariables}
      />
      }
    </div>
  )
}

export default ColumnTypeHelp
